import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { subHours } from 'date-fns';
import { ofType } from 'redux-observable';
import { finalize, from, map, mergeMap, catchError, of } from 'rxjs';
import { formatDate } from '@spa/shared/utils';
import { pricingRequest } from '@spa/shared/clients/core';
import { offerViews as getOfferViews } from '@spa/shared/clients/analytics';
import { buildPriceDetails } from '@spa/offer/utils/transformers/priceDetails';
import { getPhotosOrientation, groupGridPhotos, groupPhotosByUnit } from '@spa/shared/utils/photos';
import { OFFER_ACTION_TYPES, setPriceDetailsData, setPriceDetailsLoading, setOfferViews } from '../../actions/offer';
export var generateGalleryGridEpic = function generateGalleryGridEpic(action$, state$) {
  return action$.pipe(ofType(OFFER_ACTION_TYPES.GENERATE_GALLERY_GRID), mergeMap(function () {
    return from(getPhotosOrientation(state$.value.offer.photosModal.photos)).pipe(map(function (photos) {
      var groupedPhotos = groupPhotosByUnit(photos);
      var grid = Object.keys(groupedPhotos).reduce(function (acc, unitType) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, unitType, groupGridPhotos(groupedPhotos[unitType])));
      }, {});
      return {
        type: OFFER_ACTION_TYPES.GENERATE_GALLERY_GRID_SUCCESS,
        payload: {
          grid: grid
        }
      };
    }));
  }));
};
export var requestPriceDetails = function requestPriceDetails(action$, state$, _ref) {
  var dispatch = _ref.store.dispatch;
  return action$.pipe(ofType(OFFER_ACTION_TYPES.REQUEST_PRICE_DETAILS_DATA), mergeMap(function () {
    var _state$$value$offer$p = state$.value.offer.priceDetails.request,
      guests = _state$$value$offer$p.guests,
      moveIn = _state$$value$offer$p.moveIn,
      moveOut = _state$$value$offer$p.moveOut,
      optionId = _state$$value$offer$p.optionId;
    var offerAggregate = state$.value.offer.offerAggregate;
    dispatch(setPriceDetailsLoading({
      isLoading: true
    }));
    return from(pricingRequest(buildPriceDetails({
      offerAggregate: offerAggregate,
      query: {
        guests: guests,
        moveIn: moveIn,
        moveOut: moveOut,
        optionId: optionId
      }
    }))).pipe(map(function (priceDetails) {
      return setPriceDetailsData({
        priceDetails: priceDetails
      });
    }), finalize(function () {
      return dispatch(setPriceDetailsLoading({
        isLoading: false
      }));
    }), catchError(function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          response: {
            data: {
              message: 'Unexpected error!'
            }
          }
        },
        data = _ref2.response.data;
      return of({
        type: OFFER_ACTION_TYPES.SET_PRICE_DETAILS_ERROR,
        payload: {
          error: data
        }
      });
    }));
  }));
};
export var requestOfferViews = function requestOfferViews(action$, state$, _ref3) {
  var dispatch = _ref3.store.dispatch;
  return action$.pipe(ofType(OFFER_ACTION_TYPES.GET_OFFER_VIEWS_REQUEST), mergeMap(function (_ref4) {
    var payload = _ref4.payload;
    var now = new Date();
    var lastTwelveHours = subHours(now, 12);
    var offerId = state$.value.offer.offerAggregate.accommodation_offer.id;
    var locale = payload.locale;
    return from(getOfferViews({
      offer_id: offerId,
      start_date: formatDate(lastTwelveHours, locale),
      end_date: formatDate(now, locale)
    })).pipe(map(function (offerViews) {
      return setOfferViews(offerViews);
    }), catchError(function (response) {
      return of({
        type: OFFER_ACTION_TYPES.SET_OFFER_VIEWS_ERROR,
        payload: {
          error: response
        }
      });
    }));
  }));
};